import React from 'react';
import { Grow, styled } from "@mui/material";
import { MaterialDesignContent, SnackbarProvider } from "notistack";

function CustomSnackbarProvider(props: { children: React.ReactNode }) {
    // スタイルをカスタマイズ
    const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
        '&.notistack-MuiContent-info': {
            backgroundColor: theme.palette.info.main + "a0", // 半透明にする
            color: theme.palette.info.contrastText,
        },
        '&.notistack-MuiContent-warning': {
            backgroundColor: theme.palette.warning.main + "a0", // 半透明にする
            color: theme.palette.warning.contrastText,
        },
        '&.notistack-MuiContent-error': {
            backgroundColor: theme.palette.error.main + "a0", // 半透明にする
            color: theme.palette.error.contrastText,
        },
        '&.notistack-MuiContent-success': {
            backgroundColor: theme.palette.success.main + "a0", // 半透明にする
            color: theme.palette.success.contrastText,
        },
    }));

    return <SnackbarProvider
        maxSnack={5}
        TransitionComponent={Grow}
        Components={{
            info: StyledMaterialDesignContent,
            warning: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
            success: StyledMaterialDesignContent,
        }}>
        {props.children}
    </SnackbarProvider>;
}

export default CustomSnackbarProvider;